<template>
  <div class="page">
    <!-- 筛选 -->
    <div class="filter">
      <el-input placeholder="请输入内容" v-model="keyword" clearable prefix-icon="el-icon-search" class="sousuo"
        size="small">
      </el-input>
      <el-button type="warning" @click="handelComClick" size="small">搜索</el-button>
      <div class="filterName">价格：</div>
      <div style="display: flex; align-items: center; margin-right: 4px">
        <el-input v-model="minPrice" placeholder="最低价" size="small" style="width: 74px"></el-input>
        <div>-</div>
        <el-input v-model="maxPrice" placeholder="最高价" size="small" style="width: 74px"></el-input>
      </div>
      <el-button type="warning" @click="handelComClick" size="small">搜索</el-button>
      <div class="filterName">宠物状态：</div>
      <el-select v-model="petStatu" placeholder="请选择" class="titleSelect" style="width: 118px" size="small"
        @change="handelComClick">
        <el-option v-for="item in petStatus" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <div class="filterName" v-if="shopType == 0">门店：</div>
      <el-select v-model="shopId" placeholder="请选择" class="titleSelect" style="width: 100px" size="small"
        @change="handelComClick" v-if="shopType == 0">
        <el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <div style="margin-left: 20px">
        <el-button :disabled="exportDisabled" type="warning" @click="exportPetList" size="small">下载活体列表</el-button>
        <el-button :disabled="warningDisabled" type="warning" @click="exportWarninglist"
          size="small">下载活体库存预警表</el-button>
      </div>
      <div style="flex: 1; text-align: right">
        <el-button type="warning" plain size="small" style="margin-right: 20px"
          @click="handelFilterClick">筛选</el-button>
      </div>
    </div>
    <div class="allpet">全部({{ petCount }})</div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" class="deathTable">
      <el-table-column prop="epromNo" label="芯片编号" width="150">
      </el-table-column>
      <el-table-column prop="insideNo" label="脖圈号" width="150">
      </el-table-column>
      <el-table-column prop="applyType.title" label="分类" width="50">
      </el-table-column>
      <el-table-column prop="breedInfo.name" label="品种">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.breedInfo.name" placement="right">
            <span>{{ scope.row.breedInfo.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="insideName" label="名称">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <img :src="scope.row.cover" style="width: 300px" />
            </div>
            <div>{{ scope.row.insideName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="petSex" label="性别" width="60"> </el-table-column>
      <el-table-column label="价格" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.specialType == 0">{{ scope.row.petLevel.price }}</span>
          <span v-if="scope.row.specialType == 1">{{ scope.row.sale_price }}</span>

        </template>
      </el-table-column>
      <el-table-column label="宠物状态">
        <template slot-scope="scope">
          <span v-if="scope.row.saleStatus.value == '1'">可销售</span>
          <span v-if="scope.row.saleStatus.value == '2'">预定</span>
          <span v-if="scope.row.saleStatus.value == '3'">转移中</span>
          <span v-if="scope.row.saleStatus.value == '4'">锁定中</span>
          <span v-if="scope.row.saleStatus.value == '5'">新增</span>
          <span v-if="scope.row.saleStatus.value == '6'">质检完成</span>
          <span v-if="scope.row.saleStatus.value == '10'">退回</span>
        </template>
      </el-table-column>
      <el-table-column prop="feedShop" label="宠物位置">
        <template slot-scope="scope">
          <span>
            {{
        !scope.row.feedShop.area_id
          ? "--"
          : scope.row.feedShop.area_name +
          "--" +
          scope.row.feedShop.cage_name
      }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="任务" width="60">
        <template slot-scope="scope">
          <el-popover placement="bottom" width="180px" trigger="click">
            <el-table :data="scope.row.taskDetail">
              <el-table-column property="taskName" label="任务类型" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.growTaskPlanWay == '1'">日任务</span>
                  <span v-if="scope.row.growTaskPlanWay == '2'">周任务</span>
                  <span v-if="scope.row.growTaskPlanWay == '3'">月任务</span>
                </template>
              </el-table-column>
              <el-table-column property="taskName" label="任务名称" align="center"></el-table-column>
              <el-table-column property="name" label="任务情况" align="center">
                <template slot-scope="scope">
                  {{ scope.row.taskFinishTimes }}/{{ scope.row.taskTotalTimes }}
                </template>
              </el-table-column>
            </el-table>
            <i class="el-icon-view" style="color: #f5882a; margin-left: 4px" slot="reference"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="负责人">
        <template slot-scope="scope">
          <el-popover placement="bottom" width="180px" trigger="click">
            <div style="width: 150px; padding: 12px">
              <div class="staff_item title">
                <div>类型</div>
                <div>负责人</div>
              </div>
              <div class="staff_item" v-if="scope.row.feedShop.beautician_name">
                <div>美容师</div>
                <div>
                  {{ scope.row.feedShop.beautician_name }}
                </div>
              </div>
              <div class="staff_item" v-if="scope.row.feedShop.breeder_name">
                <div>饲养员</div>
                <div>
                  {{ scope.row.feedShop.breeder_name }}
                </div>
              </div>
              <div class="staff_item" v-if="scope.row.feedShop.doctor_name">
                <div>医生</div>
                <div>
                  {{ scope.row.feedShop.doctor_name }}
                </div>
              </div>
              <div class="staff_item" v-if="scope.row.feedShop.doctor_assistant_name">
                <div>医助</div>
                <div>
                  {{ scope.row.feedShop.doctor_assistant_name }}
                </div>
              </div>
              <div class="staff_item" style="text-align: center" v-if="!getCount(scope.row.feedShop)">
                暂无数据
              </div>
            </div>
            <i class="el-icon-view" style="color: #f5882a; margin-left: 4px" slot="reference"><span
                style="color: black; margin-left: 8px">{{ getCount(scope.row.feedShop) }}/4</span>
            </i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="scope.row.saleStatus.value == '10'"
            @click="changePet(scope.row._id)">重新提交</el-button>
          <el-button type="text" size="small" @click="changeCage(scope.row._id)">更换笼子</el-button>
          <el-button type="text" size="small" @click="handelNavClick(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <page :total="page.total" :page="page.page" @change="changePage" style="margin-top: 12px"></page>
    <!-- 宠物更换房子 -->
    <div v-if="petCageState">
      <drawerPetCage :petId="petId" @submit="submit_drawerStatus"></drawerPetCage>
    </div>
    <!-- 筛选 -->
    <el-drawer title="筛选" :modal="false" size="40%" :visible.sync="filterDrawer" custom-class="drawersend"
      direction="rtl">
      <div class="sx">
        <div class="sxMsg">
          <div class="line"></div>
          <div class="comWrap">
            <div class="comView">
              <div class="comName">宠物类型:</div>
              <div class="comTab">
                <div @click="tab = 0" :style="{ color: tab == 0 ? '#F5882A' : '' }">
                  全部
                </div>
                <div @click="tab = 1" :style="{ color: tab == 1 ? '#F5882A' : '' }">
                  猫
                </div>
                <div @click="tab = 2" :style="{ color: tab == 2 ? '#F5882A' : '' }">
                  狗
                </div>
              </div>
            </div>
            <div class="comView" v-if="tab == 0 || tab == 1">
              <div class="comName">猫:</div>
              <div class="comTab">
                <div :style="{ color: allCat ? '#F5882A' : '' }" @click="handelAllCatClick">
                  全部
                </div>
                <div v-for="(item, index) in catData" :key="index" @click="handelCatClick(item)"
                  :style="{ color: item.isClick ? '#F5882A' : '' }">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="comView" v-if="tab == 0 || tab == 2">
              <div class="comName">犬:</div>
              <div class="comTab">
                <div :style="{ color: allDog ? '#F5882A' : '' }" @click="handelAllDogClick">
                  全部
                </div>
                <div v-for="(item, index) in dogData" :key="index" @click="handelDogClick(item)"
                  :style="{ color: item.isClick ? '#F5882A' : '' }">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="comView">
              <div class="comName">性别:</div>
              <div class="comTab">
                <div v-for="(item, index) in sexs" :key="index" @click="handelSexClick(item, index)"
                  :style="{ color: index == sexIndex ? '#F5882A' : '' }">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="comView">
              <div class="comName">疫苗针数:</div>
              <div class="comTab">
                <div v-for="(item, index) in vaccines" :key="index" @click="handelVaccineClick(item, index)"
                  :style="{ color: index == vaccineIndex ? '#F5882A' : '' }">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="comView">
              <div class="comName">年龄:</div>
              <div class="comTab">
                <div v-for="(item, index) in ages" :key="index" @click="handelAgeClick(item, index)"
                  :style="{ color: index == ageIndex ? '#F5882A' : '' }">
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sxBtn">
          <div @click="resetClick">重置</div>
          <div @click="handelCertainClick">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";
import page from "@/components/page.vue";
import { petShop, petCount, breedTree } from "@/api/purchaseApi.js";
import drawerPetCage from "../../../components/drawerPetCage/drawer_petCage.vue";
export default {
  components: {
    page,
    drawerPetCage,
  },
  props: {
    shopType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      warningDisabled: false,
      exportDisabled: false,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      petId: "",
      petCageState: false,
      tableData: [],
      keyword: "", //列表搜索内容
      deathDate: "", //亡故日期
      petStatu: "-1", //宠物状态 -1全部 1可销售 2锁定中 3转移中
      petStatus: [
        {
          label: "全部",
          value: "-1",
        },
        {
          label: "可销售",
          value: "1",
        },
        {
          label: "预定",
          value: "2",
        },
        {
          label: "转移中",
          value: "3",
        },
        {
          label: "锁定中",
          value: "4",
        },
        {
          label: "新增",
          value: "5",
        },
        {
          label: "质检完成",
          value: "6",
        },
        {
          label: "退回",
          value: "10",
        },
      ],
      petCount: "", //宠物数量
      filterDrawer: false, //筛选弹框
      dogData: [], //狗数据
      catData: [], //猫数据
      tab: 0,
      allCat: true,
      allDog: true,
      categoryId: "",
      shops: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "5e9412e0b2bfbc089daerr12",
          label: "金水区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr14",
          label: "指挥中心",
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          label: "郑东新区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr10",
          label: "驯养中心",
        },
        { value: "5e9412e0b2bfbc089daerr11", label: "小程序店" },
      ],
      shopId: "", //门店id
      minPrice: "",
      maxPrice: "",
      sex: "",
      sexIndex: 0,
      sexs: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "公",
          label: "公",
        },
        {
          value: "母",
          label: "母",
        },
      ],
      vaccineCount: "",
      vaccineIndex: 0,
      vaccines: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "第0针",
        },
        {
          value: "1",
          label: "第1针",
        },
        {
          value: "2",
          label: "第2针",
        },
        {
          value: "3",
          label: "第3针",
        },
        {
          value: "4",
          label: "第4针",
        },
      ],
      age: "",
      ageIndex: 0,
      ages: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "0-3个月",
        },
        {
          value: "2",
          label: "3-6个月",
        },
        {
          value: "3",
          label: "6-9个月",
        },
        {
          value: "4",
          label: "9-12个月",
        },
        {
          value: "5",
          label: "1年以上",
        },
      ],
    };
  },
  mounted() {
    this.getTableData();
    this.getPetCountData();
    this.getBreedData();
    // console.log("门店跳转", this.shopType);
  },
  methods: {
    getCount(obj) {
      let num = 0;
      if (obj.beautician_name) {
        num = num + 1;
      }
      if (obj.breeder_name) {
        num = num + 1;
      }
      if (obj.doctor_name) {
        num = num + 1;
      }
      if (obj.doctor_assistant_name) {
        num = num + 1;
      }
      return num;
    },
    //下载活体库存预警列表
    exportWarninglist() {
      this.warningDisabled = true;
      let loading = this.$loading();
      axios
        .get(
          process.env.VUE_APP_Url_baseData +
          "/api/product/pet/stock/warninglist/export",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          loading.close();
          console.log(response.data, "地址---");
          var href = window.URL.createObjectURL(response.data); //创建下载的链接
          var downloadElement = document.createElement("a");
          downloadElement.href = href;
          downloadElement.download = "活体库存预警列表导出.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.warningDisabled = false;
        });
    },
    // 下载活体列表
    exportPetList() {
      this.exportDisabled = true;
      let loading = this.$loading();
      axios
        .get(
          process.env.VUE_APP_Url_baseData + "/api/product/pet/list/export",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          loading.close();
          console.log(response.data, "地址---");
          var href = window.URL.createObjectURL(response.data); //创建下载的链接
          var downloadElement = document.createElement("a");
          downloadElement.href = href;
          downloadElement.download = "活体列表导出.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.exportDisabled = false;
        });
    },
    submit_drawerStatus() {
      this.petCageState = false;
      this.getTableData();
    },
    // 退回宠物重新提交
    changePet(id) {
      let params = {
       id: id,
      }
      this.$http.get( process.env.VUE_APP_Url2 + 'api/product/pet/again/check/flow', params).then(res => {
        if (res.code === 0) {
          if(res.data==true){
            this.$message({
							type: 'success',
							message: '已提交'
						})
            this.getTableData();
          }

        }
      })
    },
    // 更换笼子
    changeCage(id) {
      this.petId = id;
      this.petCageState = true;
    },
    //筛选
    handelComClick() {
      this.page.page = 1;
      this.getTableData();
    },
    //选择年龄
    handelAgeClick(item, index) {
      this.ageIndex = index;
      this.age = item.value;
    },
    //选择疫苗
    handelVaccineClick(item, index) {
      this.vaccineIndex = index;
      this.vaccineCount = item.value;
    },
    //选择性别
    handelSexClick(item, index) {
      this.sexIndex = index;
      this.sex = item.value;
    },
    //筛选
    handelFilterClick() {
      this.filterDrawer = true;
    },
    //弹框确认
    handelCertainClick() {
      if (this.tab == 0) {
        //全部
        if (this.allCat && this.allDog) {
          this.categoryId = "";
        }
        if (!this.allCat && this.allDog) {
          let catStr = "";
          for (let i = 0; i < this.catData.length; i++) {
            if (this.catData[i].isClick) {
              catStr = catStr + this.catData[i].id + ",";
            }
          }
          this.categoryId = catStr;
        }
        if (this.allCat && !this.allDog) {
          let dogStr = "";
          for (let i = 0; i < this.dogData.length; i++) {
            if (this.dogData[i].isClick) {
              dogStr = dogStr + this.dogData[i].id + ",";
            }
          }
          this.categoryId = dogStr;
        }
        if (!this.allCat && !this.allDog) {
          let catStr = "";
          for (let i = 0; i < this.catData.length; i++) {
            if (this.catData[i].isClick) {
              catStr = catStr + this.catData[i].id + ",";
            }
          }
          let dogStr = "";
          for (let j = 0; j < this.dogData.length; j++) {
            if (this.dogData[j].isClick) {
              dogStr = dogStr + this.dogData[j].id + ",";
            }
          }
          this.categoryId = dogStr + catStr;
        }
      } else if (this.tab == 1) {
        //猫
        let catStr = "";
        if (this.allCat) {
          for (let i = 0; i < this.catData.length; i++) {
            catStr = catStr + this.catData[i].id + ",";
          }
        } else {
          for (let i = 0; i < this.catData.length; i++) {
            if (this.catData[i].isClick) {
              catStr = catStr + this.catData[i].id + ",";
            }
          }
        }
        this.categoryId = catStr;
      } else if (this.tab == 2) {
        //狗
        let dogStr = "";
        if (this.allDog) {
          for (let i = 0; i < this.dogData.length; i++) {
            dogStr = dogStr + this.dogData[i].id + ",";
          }
        } else {
          for (let i = 0; i < this.dogData.length; i++) {
            if (this.dogData[i].isClick) {
              dogStr = dogStr + this.dogData[i].id + ",";
            }
          }
        }
        this.categoryId = dogStr;
      }
      console.log(this.categoryId);
      this.filterDrawer = false;
      this.page.page = 1;
      this.getTableData();
    },
    //弹框重置
    resetClick() {
      this.tab = 0;
      this.allCat = true;
      this.allDog = true;
      for (let i = 0; i < this.catData.length; i++) {
        this.catData[i].isClick = false;
      }
      for (let j = 0; j < this.dogData.length; j++) {
        this.dogData[j].isClick = false;
      }
      this.page.page = 1;
      this.keyword = "";
      if (this.shopType == 0) {
        this.shopId = "";
      }
      this.petStatu = "-1";
      this.minPrice = "";
      this.maxPrice = "";
      this.sex = "";
      this.sexIndex = 0;
      this.vaccineCount = "";
      this.vaccineIndex = 0;
      this.age = "";
      this.ageIndex = 0;
      this.handelCertainClick();
    },
    //全部猫
    handelAllCatClick() {
      this.allCat = true;
      for (let i = 0; i < this.catData.length; i++) {
        this.catData[i].isClick = false;
      }
    },
    //全部狗
    handelAllDogClick() {
      this.allCat = true;
      for (let i = 0; i < this.dogData.length; i++) {
        this.dogData[i].isClick = false;
      }
    },
    //选择狗品种
    handelDogClick(item) {
      console.log(item);
      item.isClick = !item.isClick;
      let num = 0;
      for (let i = 0; i < this.dogData.length; i++) {
        if (this.dogData[i].isClick) {
          num++;
          this.allDog = false;
        }
      }
      console.log(num);
      if (num == 0) {
        this.allDog = true;
      }
    },
    //选择猫品种
    handelCatClick(item) {
      console.log(item);
      item.isClick = !item.isClick;
      let num = 0;
      for (let i = 0; i < this.catData.length; i++) {
        if (this.catData[i].isClick) {
          num++;
          this.allCat = false;
        }
      }
      console.log(num);
      if (num == 0) {
        this.allCat = true;
      }
    },
    //获取品种
    getBreedData() {
      let that = this;
      let params = {
        category: "活体",
      };
      breedTree(params).then((res) => {
        if (res.code == 0) {
          // console.log('品种', res)
          let catData = res.data[0].children[0].children;
          let dogData = res.data[0].children[1].children;
          for (let i = 0; i < catData.length; i++) {
            catData[i].isClick = false;
          }
          for (let j = 0; j < dogData.length; j++) {
            dogData[j].isClick = false;
          }
          that.catData = catData;
          that.dogData = dogData;
        }
      });
    },
    //跳转
    handelNavClick(row) {
      let query = {
        id: row._id,
      };
      this.$router.push({
        path: "detail",
        query,
      });
    },
    //获取宠物数量
    getPetCountData() {
      let params = {};
      if (this.shopType == 0) {
        params.shopId = "5e9412e0b2bfbc089daerr14";
      } else {
        params.shopId = this.$store.state.shopId;
      }
      petCount(params).then((res) => {
        if (res.code == 0) {
          console.log("数量", res);
          this.petCount = res.data;
        }
      });
    },
    //获取数据
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        petStatus: this.petStatu,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        sex: this.sex,
        vaccineCount: this.vaccineCount,
        age: this.age,
        categoryId: this.categoryId,
      };
      if (this.shopType == 0) {
        params.shopId = this.shopId;
      } else {
        params.shopId = this.$store.state.shopId;
      }
      petShop(params).then((res) => {
        if (res.code == 0) {
          console.log("宠物列表", res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  background: #fffaf5;
  color: #909399;
}

.staff_item {
  font-size: 12px;
  display: flex;
  height: 40px;
  text-align: center;
  border-bottom: 1px solid #ebeef5;
  line-height: 40px;
  justify-content: space-between;
}

.page {
  min-height: 762px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;

  .filter {
    height: 58px;
    display: flex;
    align-items: center;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 20px;
      margin-right: 4px;
    }
  }

  .allpet {
    height: 28px;
    line-height: 17px;
    background: #fff;
    color: #666;
    padding-left: 20px;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #f2f2f2;
  }

  .sx {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .comWrap {
      padding: 20px;
      font-size: 12px;
      color: #666;
      line-height: 20px;

      .comView {
        display: flex;
        margin-bottom: 16px;

        .comName {
          width: 52px;
          text-align: right;
        }

        .comTab {
          flex: 1;
          display: flex;
          flex-wrap: wrap;

          div {
            padding: 0 12px;
            border-right: 1px solid #f2f2f2;
            margin-bottom: 12px;
          }

          div:nth-of-type(1) {
            padding-left: 4px;
          }
        }
      }
    }

    .sxBtn {
      height: 40px;
      display: flex;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;

      div:nth-of-type(1) {
        flex: 1;
        background: #e1e9fb;
        color: #467eff;
      }

      div:nth-of-type(2) {
        flex: 1;
        background: #f5882a;
      }
    }
  }
}
</style>
